import Axios from "axios";
import {
    SET_BRANCH_MODULE_LIST,
    UNSET_BRANCH_MODULE_LIST,
    SET_BRANCH_WISE_MODULE_LIST,
    UNSET_BRANCH_WISE_MODULE_LIST,
    SET_TEMP_BRANCH_MODULE_LIST,
    UNSET_TEMP_BRANCH_MODULE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateBranchModule, getBranchModuleList, getBranchWiseModuleList } from "@/store/api";
// initial state
const state = {
  getBranchModuleList: [],
  getBranchWiseModuleList: [],
  getTempBranchModuleList: [],
};

const getters = {
  getBranchModuleList(state) {
    return state.getBranchModuleList;
  },
  getBranchWiseModuleList(state) {
    return state.getBranchWiseModuleList;
  },
  getTempBranchModuleList(state) {
    return state.getTempBranchModuleList;
  }
};
const mutations = {
  [SET_BRANCH_MODULE_LIST](state, data) {
    state.getBranchModuleList = data;
  },
  [UNSET_BRANCH_MODULE_LIST](state) {
    state.getBranchModuleList = [];
  },
  [SET_BRANCH_WISE_MODULE_LIST](state, data) {
    state.getBranchWiseModuleList = data;
  },
  [UNSET_BRANCH_WISE_MODULE_LIST](state) {
    state.getBranchWiseModuleList = [];
  },
  [SET_TEMP_BRANCH_MODULE_LIST](state, data) {
    state.getTempBranchModuleList = data;
  },
  [UNSET_TEMP_BRANCH_MODULE_LIST](state) {
    state.getTempBranchModuleList = [];
  }
};

const actions = {

  saveUpdateBranchModule({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateBranchModule, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getBranchModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getBranchModuleList, data)
        .then(function (response) {
          commit('SET_BRANCH_MODULE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BRANCH_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getBranchWiseModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getBranchWiseModuleList, data)
        .then(function (response) {
          commit('SET_BRANCH_WISE_MODULE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BRANCH_WISE_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
